import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Montserrat'],
    h1: {
      fontSize: '38px',
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: 1.3,
    },
  },
  palette: {
    background: {
      main: '#5938bd',
      secondary: 'rgba(0,0,0, 0.12)',
      success: '#2e7d32',
    },
    primary: {
      main: '#5938bd',
    },
    secondary: {
      main: 'rgba(0,0,0, 0.30)',
    },
    warning: {
      main: '#ED6C02',
    },
  },
  components: {
    MuiSkeleton: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.grey[400],
        }),
      },
      defaultProps: {
        animation: 'pulse',
      },
    },
  },
});

export { theme };
